import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

import useTranslate from 'hooks/useTranslate';

const LEGEND = [
    { color: 'green', label: 'potentiallyQualified' },
    { color: 'orange', label: 'potentiallyQualifiedWithJobOffer' },
    { color: 'black', label: 'allOtherPrograms' },
] as const;

const LegendRow: React.FC<{ color: string; label: string }> = ({ color, label }) => (
    <Stack direction="row" spacing={0.75} sx={{ alignItems: 'center', minWidth: 0 }}>
        <Box
            sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: color,
                flexShrink: 0,
            }}
        />
        <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.4 }}>
            {label}
        </Typography>
    </Stack>
);

export const QualificationLegend: React.FC = () => {
    const { translate } = useTranslate();

    return (
        <Box
            sx={{
                mb: 1.5,
                px: 1.5,
                py: 1.25,
                borderRadius: 1.5,
                bgcolor: 'action.hover',
            }}
        >
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={{ xs: 0.75, sm: 2 }}
                useFlexGap
                sx={{ flexWrap: 'wrap' }}
            >
                {LEGEND.map((item) => (
                    <LegendRow key={item.label} color={item.color} label={translate(item.label)} />
                ))}
            </Stack>
        </Box>
    );
};
